import { supabaseClient } from 'supabase'
import { ApplicationRow } from './deskTypes'

/** One editor candidate (an applications row) for the candidate screen. */
export const queryDeskCandidate = async (id: number): Promise<ApplicationRow> => {
  const { data, error } = await supabaseClient
    .from('applications')
    .select('*')
    .eq('id', id)
    .single()

  if (error) {
    throw error
  }
  return data
}
